
import Api from '@/utils/api';
import NotData from '../NoData/NoData.vue';
import LoadMore from 'vux/src/components/load-more/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'

import {
search
} from '../../api';
export default {
components: {
NotData,
LoadMore,
Scroller,
XImg
},
data() {
return {
listIndex: "-1",
loadText: '正在加载',
scrollH: "300px",
isMoreList: false,
productList: [],
searchText: '',
pagination: {
page: 1,
pageSize: 6
}
}
},
methods: {
search(keyword) {
this.searchText = keyword
this.productList = []
this.getProductList()
},
addCart(item_id, sku_id, className, url) {
let imgBox = document.querySelector(`.${className}`);
let relative = imgBox.getBoundingClientRect();

this.$store.commit('updateClassifyAnimate', {
x: relative.left,
y: relative.top,
headPic: url,
item_id: item_id,
sku_id: sku_id,
random: Math.random() * 10000
});

},
toDetail(id) {
this.$router.push({
name: 'detail',
params: {
id: id
}
});
},
onScrollBtm() {
if(this.isMoreList){
this.isMoreList = false
this.pagination.page ++
this.getProductList()
}
},
getProductList () {
const searchParams = {
page: this.pagination.page,
pageSize: this.pagination.pageSize
}
if(this.searchText){
searchParams.name = this.searchText
}

this.loadText = '正在加载'
Api.getProductList(searchParams)
.then(res => {
this.productList = this.productList.concat(res.data)
if(this.productList.length < parseInt(res.headers.total)){
this.isMoreList = true
}else {
this.isMoreList = false
this.loadText = '没有更多数据'
}
this.$nextTick(() => {
this.$refs.scrollerEvent.reset()
})
})
}
},
computed: {
keyWorld() {
return this.$store.state.search.n;
},
r_sort() {
return this.$store.state.search.r_sort;
},
template() {
return this.$store.state.search.template;
}
},
created() {
setTimeout(() => {
var fontSize = parseInt(document.documentElement.style.fontSize);
var h = 0.94;

this.scrollH = document.documentElement.clientHeight - parseInt(h * fontSize) + 'px';
console.log(this.scrollH)
});
this.search(this.$route.params.keyworld);
},
mounted() {
},
watch: {
keyWorld() {
this.search(this.keyWorld);
}
}
}



// WEBPACK FOOTER //
// ./src/components/Search/content.vue